import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import axios from 'axios';
import {
  Button,
  Box,
  Grid,
  LinearProgress,
  Paper
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Link } from "react-router-dom";
// components
import Table from "./component/Table/Table";
import { Typography } from "../../components/Wrappers/Wrappers";
import Widget from "../../components/Widget/Widget";
// API
import {
  formatGetAllTasksURL
 } from '../../utils/apis';
// Route
import {
  CREATE,
} from '../../utils/constants';
// Formatter
import {
  extractSArray,
  formatRequestHeader
} from '../../utils/formatter';

const useStyles = makeStyles(theme => ({
  tableOverflow: {
    overflow: 'auto'
  }
}))

function StarredPage(props) {
  const { accessTokenState } = props;
  const classes = useStyles();
  const [tasks, setTasks] = useState([]);
  const [isPageLoading, setIsPageLoading] = useState(true);

  const filterStarredItem = array => {
    if(Array.isArray(array)) {
      return array.filter(item => item['isStarred']['BOOL'] === true);
    } else {
      return [];
    }

  }

  useEffect(() => {
    accessTokenState && axios.get(formatGetAllTasksURL(), {
      headers: formatRequestHeader(accessTokenState)
    }).then(resp => {
      // Use for tracking the mounted status
      const newTasks = filterStarredItem(resp['data']);
      setTasks(newTasks);
      setIsPageLoading(false);
    }).catch(error => {
        console.error(error);
        setIsPageLoading(false);
    });
  },[accessTokenState]);

  if(isPageLoading) {
    return (
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <LinearProgress />
        </Grid>
      </Grid>
    )
  }

  return (
    <>
    <Paper spacing={4} style={{minHeight: '100vh',minWidth: '50vw'}}>
      <Grid container spacing={4}>
        {
          tasks.length !== 0 ?
          <Grid item xs={12}>
            <Table
            data={extractSArray(tasks)} />
          </Grid>
          :
          <Grid container spacing={4}>
            <Grid container spacing={4}>
              <Grid item xs={1} md={3}>
                <Paper></Paper>
              </Grid>
              <Grid item xs={10} md={6}>
                <Box m={4}>
                  <Widget title="Instruction" disableWidgetMenu>
                    <div className={classes.dashedBorder}>

                      <Typography variant="h6">
                        You do not have any starred tasks
                      </Typography>
                      <Typography variant="h6">
                        Go to Create page to upload your file
                      </Typography>

                    </div>
                  </Widget>
                </Box>
              </Grid>
              <Grid item xs={1} md={3}>
                <Paper></Paper>
              </Grid>
            </Grid>
            <Grid container spacing={6}>
              <Grid item xs={3} md={5}>
                <Paper />
              </Grid>
              <Grid item xs={7} md={4}>
                <Box mr={4} mt={4}>
                  <Button
                    component={Link}
                    variant="contained"
                    color="primary"
                    to={CREATE}
                  >
                    Get Started
                  </Button>
                </Box>
              </Grid>
              <Grid item xs={2} md={3}>
                <Paper />
              </Grid>
            </Grid>
          </Grid>
        }
      </Grid>
    </Paper>

    </>
  );
}


const mapStateToProps = state => ({
  accessTokenState: state.AuthOptions.accessToken,
});

export default connect(mapStateToProps)(StarredPage);